<dx-toolbar class="panel-toolbar" (onContentReady)="onContentReady($event)">
  <dxi-item *ngIf="chevron" location="before" locateInMenu="never" widget="dxButton"
            [options]="chevronButtonOptions">
  </dxi-item>

  <dxi-item location="before" locateInMenu="never">
    <ng-content select=".beforeCustom"></ng-content>
  </dxi-item>

  <dxi-item location="center" locateInMenu="never">
    <ng-content select=".centerCustom"></ng-content>
  </dxi-item>

  <dxi-item location="after" locateInMenu="never">
    <ng-content select=".afterCustom"></ng-content>
  </dxi-item>
  <ng-container *ngIf="!twoLineEnable">
    <ng-container *ngIf="dynamicButtons && showDynamicButtons">
      <dxi-item location="after" locateInMenu="auto" *ngFor="let dynamicButton of dynamicButtons; trackBy: trackByFn">
        <div class="dynamic-button-container">
          <dx-button
            [style]="dynamicButton?.style"
            id="dynamicButtonTop"
            [disabled]="(dynamicButton?.disabled) || (dynamicButton?.donemKontrolYn ? (!donemAktif) : false)"
            [text]="dynamicButton?.text"
            [icon]="dynamicButton.icon"
            [type]="dynamicButton.type"
            [hint]="dynamicButton.hint"
            [width]="dynamicButton.width ? dynamicButton.width : 'auto'"
            [stylingMode]="dynamicButton.stylingMode"
            (click)="handleDynamicButtonClick(dynamicButton)"
          ></dx-button>
        </div>
      </dxi-item>
    </ng-container>

  </ng-container>


</dx-toolbar>


<ng-container *ngIf="twoLineEnable">
  <dx-toolbar class="second-line-toolbar">
    <ng-container *ngIf="dynamicButtons && showDynamicButtons">
      <dxi-item location="center" locateInMenu="auto" *ngFor="let dynamicButton of dynamicButtons; trackBy: trackByFn">
        <div class="dynamic-button-container">
          <dx-button
            [style]="dynamicButton?.style"
            id="dynamicButtonBottom"
            [disabled]="dynamicButton?.donemKontrolYn ? (!donemAktif ) : false"
            [text]="dynamicButton?.text"
            [icon]="dynamicButton.icon"
            [type]="dynamicButton.type"
            [hint]="dynamicButton.hint"
            [width]="dynamicButton.width ? dynamicButton.width : 'auto'"
            [stylingMode]="dynamicButton.stylingMode"
            (click)="handleDynamicButtonClick(dynamicButton)"
          ></dx-button>
        </div>
      </dxi-item>
    </ng-container>


  </dx-toolbar>
</ng-container>
